// Editable fields configuration
export const EDITABLE_FIELDS = [
  'keyword', 'section', 'broadHead'
];

export const columns = [
  {
    id: 'sectionKeyword',
    label: 'Section',
    width: '80px',
    editable: true
  },
  {
    id: 'broadHead',
    label: 'Broad head',
    width: '200px',
    editable: true
  },
  {
    id: 'keyword',
    label: 'Keyword',
    width: '450px',
    editable: true,
    isFormatted: false
  },

]

export const searchFields = [
  ...columns.map(col => {
    return {
      id: col.id,
      label: col.label,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    };
  }),
];
